var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "import"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 1",
    d: "M24.5 37.2002C24.5 38.0286 25.1716 38.7002 26 38.7002C26.8284 38.7002 27.5 38.0286 27.5 37.2002L24.5 37.2002ZM27.0607 0.939533C26.4749 0.353748 25.5251 0.353748 24.9393 0.939533L15.3934 10.4855C14.8076 11.0713 14.8076 12.021 15.3934 12.6068C15.9792 13.1926 16.9289 13.1926 17.5147 12.6068L26 4.12151L34.4853 12.6068C35.0711 13.1926 36.0208 13.1926 36.6066 12.6068C37.1924 12.021 37.1924 11.0713 36.6066 10.4855L27.0607 0.939533ZM27.5 37.2002V2.00019L24.5 2.00019V37.2002L27.5 37.2002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M2 37.2002L2 49.0002C2 49.5525 2.44772 50.0002 3 50.0002L49 50.0002C49.5523 50.0002 50 49.5525 50 49.0002V37.2002",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/upload.icon.3bd553ff3f55534f7ccaaa5079397854.svg";
export { ForwardRef as ReactComponent };